import { render, staticRenderFns } from "./PhoneModification.vue?vue&type=template&id=b054fb16&scoped=true&"
import script from "./PhoneModification.vue?vue&type=script&lang=js&"
export * from "./PhoneModification.vue?vue&type=script&lang=js&"
import style0 from "./PhoneModification.vue?vue&type=style&index=0&id=b054fb16&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b054fb16",
  null
  
)

export default component.exports